import axios from "../axiosPlugin.js";

export const signageDetailService = (data, loading = true) => {
  return axios({
    url: "/api/signage/detail",
    method: "get",
    data: {
      data,
      loading,
    },
  });
};

export const updateSignageService = (data, loading = true) => {
  return axios({
    url: "/api/signage/save",
    method: "post",
    data: {
      data,
      loading,
    },
  });
};